import { cn } from "@/lib/utils";
import type { PriceLineItemSize } from "./PriceLineItem.types";

type PriceLineItemLeftOffsetProps = {
  leftOffset: "left" | "indicator";
  size?: PriceLineItemSize;
};

/**
 * Left offset chrome based on LineItemBullet: left keeps alignment space,
 * indicator shows the purple change-dot.
 *
 * Rail height matches the primary label line-height so the dot stays centered
 * across size variants (body-1 → 16px, body-2/3 → 24px).
 */
const PriceLineItemLeftOffset = ({
  leftOffset,
  size = "medium",
}: PriceLineItemLeftOffsetProps) => {
  return (
    <span
      className={cn(
        "tw-flex tw-w-8 tw-shrink-0 tw-items-center tw-justify-center",
        size === "small" ? "tw-h-16" : "tw-h-24",
      )}
    >
      <span
        aria-hidden="true"
        data-testid="price-line-item-left-offset-indicator"
        className={cn(
          "tw-block tw-h-6 tw-w-6 tw-rounded-full tw-bg-purple-600",
          {
            "tw-invisible": leftOffset === "left",
          },
        )}
      />
    </span>
  );
};

PriceLineItemLeftOffset.displayName = "PriceLineItemLeftOffset";

export { PriceLineItemLeftOffset, type PriceLineItemLeftOffsetProps };
